import { useCallback, useEffect, useState } from 'react';
import FrameList from '../../FiltersContent/FrameList/FrameListPanel';
import { FrameListPanelProps } from './FrameListPanel.types';

const FrameListPanel: React.FC<FrameListPanelProps> = ({
  initialSelectedRouteFrameCodes,
  initialUploadedListOfFiles,
  localSearchOptions,
  excludedSearchOptions,
  onConfirm,
  onCancel,
}) => {
  const [selectedRouteFrameCodes, setSelectedRouteFrameCodes] = useState(initialSelectedRouteFrameCodes);
  const [uploadedListOfFiles, setUploadedListOfFiles] = useState(initialUploadedListOfFiles);

  useEffect(() => {
    setSelectedRouteFrameCodes(initialSelectedRouteFrameCodes);
    setUploadedListOfFiles(initialUploadedListOfFiles);
  }, [initialSelectedRouteFrameCodes, initialUploadedListOfFiles]);

  const onRemoveFile = useCallback(
    (frameFileName: string) => {
      const updatedUploadedListOfFiles = uploadedListOfFiles.filter(({ name }) => name !== frameFileName);

      setUploadedListOfFiles(updatedUploadedListOfFiles);
    },
    [uploadedListOfFiles],
  );

  return (
    <FrameList
      onConfirm={() =>
        onConfirm({ frameList: { routeFrameCodes: selectedRouteFrameCodes, listFiles: uploadedListOfFiles } })
      }
      onCancel={onCancel}
      onRemoveFile={onRemoveFile}
      initialSelectedRouteFrameCodes={initialSelectedRouteFrameCodes}
      initialUploadedListOfFiles={initialUploadedListOfFiles}
      selectedRouteFrameCodes={selectedRouteFrameCodes}
      setSelectedRouteFrameCodes={setSelectedRouteFrameCodes}
      uploadedListOfFiles={uploadedListOfFiles}
      setUploadedListOfFiles={setUploadedListOfFiles}
      cancelButtonLabel="Back"
      confirmButtonLabel="Save"
      isSubsection
      localSearchOptions={localSearchOptions}
      excludedSearchOptions={excludedSearchOptions}
    />
  );
};

export default FrameListPanel;
